const prosaCodeResolver = (code) => {

var regexSuccesfullProcessTrans = /^(000\.000\.|000\.100\.1|000\.[36])/g;
var regexSuccesfullProcessManualReview = /^(000\.400\.0[^3]|000\.400\.100)/g;
var regexPendingTrans = /^(000\.200)/g;
var regexPendingTransSeveDays = /^(800\.400\.5|100\.400\.500)/g;
var regexRejectedTrans3D = /^(000\.400\.[1][0-9][1-9]|000\.400\.2)/g;
var regexRejectedExternalBank = /^(800\.[17]00|800\.800\.[123])/g;
var regexRejectedCommErrors = /^(900\.[1234]00|000\.400\.030)/g;
var regexRejectedSystemError = /^(800\.[56]|999\.|600\.1|800\.800\.8)/g;
var regexRejectedAsynchWorkf = /^(100\.39[765])/g;
var regexSofDecline = /^(300\.100\.100)/g;
var regexRejectedExtRiskSystem = /^(100\.400\.[0-3]|100\.38|100\.370\.100|100\.370\.11)/g;
var regexRejectedAddressValidation = /^(800\.400\.1)/g;
var regex3DSecure = /^(800\.400\.2|100\.380\.4|100\.390)/g;
var regexRejectedBlackListVal = /^(100\.100\.701|800\.[32])/g;
var regexRejectedRiskValidation = /^(800\.1[123456]0)/g;
var regexRejectedConfValidation = /^(600\.[23]|500\.[12]|800\.121)/g;
var regexRejectedRegistrationValidation = /^(100\.[13]50)/g;
var regexRejectedJobValidation = /^(100\.250|100\.360)/g;
var regexRejectedReferenceValidation = /^(700\.[1345][05]0)/g;
var regexRejectedFormatValidation = /^(200\.[123]|100\.[53][07]|800\.900|100\.[69]00\.500)/g;
var regexRejectedAddressValidation2 = /^(100\.800)/g;
var regexRejectedContactValidation = /^(100\.[97]00)/g;
var regexRejectedAccountValidation = /^(100\.100|100.2[01])/g;
var regexRejectedAmountValidation = /^(100\.55)/g;
var regexRejectedRiskManagment = /^(100\.380\.[23]|100\.380\.101)/g;
var regexRejectedChargeback = /^(000\.100\.2)/g;

if(code.match(regexSuccesfullProcessTrans) != null || code.match(regexSuccesfullProcessManualReview) != null){
  return 1;
}else if(code.match(regexPendingTrans) != null || code.match(regexPendingTransSeveDays) != null){
  return 2;
}else{
  return 3;
}

};
export default (prosaCodeResolver);


// WEBPACK FOOTER //
// ./src/dashboard/invoices/payment/prosa/prosaCodeResolver.js